/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Agent_2_B2Inputs */

const en_mk_agent_2_b2 = /** @type {(inputs: Mk_Agent_2_B2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asking for a revision starts the agent again, with your note`)
};

const id_mk_agent_2_b2 = /** @type {(inputs: Mk_Agent_2_B2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minta revisi memicu agen bekerja lagi dengan catatan Anda`)
};

/**
* | output |
* | --- |
* | "Asking for a revision starts the agent again, with your note" |
*
* @param {Mk_Agent_2_B2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_agent_2_b2 = /** @type {((inputs?: Mk_Agent_2_B2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Agent_2_B2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_agent_2_b2(inputs)
	return en_mk_agent_2_b2(inputs)
});